import { render } from "./StatusChipComp.vue?vue&type=template&id=0125a497"
import script from "./StatusChipComp.vue?vue&type=script&lang=js"
export * from "./StatusChipComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__